import React, { useEffect, useState } from "react";
import "./ContactMap.css";
import Card from "react-bootstrap/Card";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import { useWebSocket } from "../../../uiUtils/useWebSocket";
import { fetchContactCardRequest } from "../../../../../store/features/actions/opportunities/contactMapCardActions";
import { getNameInitials } from "../../../../../services/commonService";
import { ContactMapPlaceholder } from "./ContactMapPlaceholder";
import NoDataComp from "../../../genericComponents/uiElements/NoDataComp";
import AccessField from "../accessEmailComp/AccessField";
import { useTaskStatus } from "../../../../../context/TaskStatusContext";
import GeneratingLoader from "../../../genericComponents/uiElements/GeneratingLoader";
import { enrichContact, enrichContactV2, getCreditBalance } from "../../../../../services/iqApiV2";
import { useUser } from "../../../../../context/UserContext";
import { useBanner } from "../../../../../context/BannerContext";
import ContactMapCardAddContact from "./ContactMapCardAddContact";
import ContactFavContact from "./contactFavComp/ContactFavContact";
import { dynamicSmartSort } from "../../../../TableComponents/dynamicSortFunction";
import ExpandableParagraph from "./expandableParagraph/ExpandableParagraph";
import { GenericCardSkeletonComponent } from "../../../genericComponents/uiElements/GenericCardSkeletonComponent";
import AccessPhoneButton from "../accessEmailComp/AccessPhoneField";
import { addStreamListener, initStreamSW, startPhoneStream } from "../../../../../streaming/streamSwClient";
import StatusIndicator from "../../../genericComponents/resizeableTable/StatusIndicator";
import GenericTagComp from "../../../genericComponents/tag/GenericTagComp";
import GenericFloatingBanner from "../../../genericComponents/uiElements/GenericFloatingBanner";

export default function ContactMapCard({ opportunityId, onContactCardClick, contact_list }) {
  const showBanner = useBanner();
  const dispatch = useDispatch();
  const [status, setStatus] = useState("Processing...");
  const [result, setResult] = useState(null);
  const { contactCardData, contactCardLoading, error } = useSelector(
    (state) => state?.contactCardReducer
  );
  const { user } = useUser();
  const [phonePendingMap, setPhonePendingMap] = useState({});
  const [phoneMap, setPhoneMap] = useState({});
  const [banner, setBanner] = useState(null);
  const triggerBanner = ({ message, type = "info", duration = 4000 }) => {
        setBanner({
          id: Date.now(),
          message,
          type,
          duration,
          title:""
        });
  };
  const handleOnAccessEmailClick = async (e, userId, apolloId, linkedInUrl) => {
    e.preventDefault();
    e.stopPropagation();
    const onSuccess = () => {
      showBanner({
        message: "Email Found",
        title: "Alert",
        type: "success",
        duration: 2000,
      });
    };

    const onError = () => {
      showBanner({
        message: "Email Not Found",
        title: "Alert",
        type: "error",
        duration: 2000,
      });
    };
    const resp = await enrichContact(
      userId,
      apolloId,
      linkedInUrl,
      onSuccess,
      onError
    );

    const updatedResult = result.map((item) =>
      item.id === apolloId ? { ...item, email: resp.email } : item
    );


    const sortedContacts = (updatedResult || []).sort((a, b) => {
      if (a.product_icp && !b.product_icp) return -1; // a comes first
      if (!a.product_icp && b.product_icp) return 1;  // b comes first
      return 0; // keep relative order if both have or don't have product_icp
      });

      setResult(sortedContacts);

  };
  const copyToClipboard = (text, type = "email") => {
    navigator.clipboard.writeText(text)
      .then(() => {

        triggerBanner({
          message: type === "phone" ? "Phone Number Copied Successfully" : "Email Copied Successfully",
          type: "success",
          duration: 10000,
        });
      })
      .catch((err) => {
        console.error('Failed to copy text: ', err);
      });
  };

  const handleOnAccessPhoneClick = async (e, userId, apolloId, phoneAccess = false) => {
    e.preventDefault();
    e.stopPropagation();
    triggerBanner({
          message: `Contact is being fetched , Might take upto 5 minutes`,
          type: "success",
          duration: 3000,
        });
    try {
      const requiredCredits = phoneAccess ? 10 : 2;
      const balance = await getCreditBalance(userId);
      if (balance < requiredCredits) {
          // Show banner if insufficient credits
  
          triggerBanner({
            message: `Insufficient credits to ${phoneAccess ? "access phone" : "access email"
              }. Please recharge to continue.`,
            type: "warning",
            duration: 10000,
          });
          return;
        }
      const resp = await enrichContactV2(userId, apolloId, phoneAccess, () => { }, () => { });

      if (phoneAccess) {
        const key = `${user.id}_${apolloId}_phone_pending`;
        localStorage.setItem(key, JSON.stringify({
          ts: Date.now()
        }));
        startPhoneStream(apolloId);
      }

      const updatedPhone1 = resp?.phone;
      setPhonePendingMap(prev => ({ ...prev, [apolloId]: true }));
      setPhoneMap(prev => ({ ...prev, [apolloId]: updatedPhone1 }));
      await Promise.resolve();
    } catch (err) {
      console.error("Failed to enrich contact:", err);
    }
  };
  const { getTaskStatus } = useTaskStatus();
  const taskStatus = getTaskStatus(`opp_sidecard_contact_map_${opportunityId}`);

  useEffect(() => {
    let removeListener = null;

    const setup = async () => {
      try {
        await initStreamSW();

        removeListener = addStreamListener((msg) => {
          if (msg.type === "PHONE_UPDATE") {
            const key = `${user?.id}_${msg.apolloId}_phone_pending`;
            localStorage.removeItem(key);
            setPhoneMap(prev => ({ ...prev, [msg.apolloId]: msg?.phone }));
            setPhonePendingMap(prev => ({ ...prev, [msg.apolloId]: false }));
          }
          if (msg.type === "PHONE_UPDATE_ERROR") {
            const key = `${user?.id}_${msg.apolloId}_phone_pending`;
            localStorage.removeItem(key);
            setPhoneMap(prev => ({ ...prev, [msg.apolloId]: "Not Found" }));
            setPhonePendingMap(prev => ({ ...prev, [msg.apolloId]: false }));
            console.log("No phone found:", msg.message);
          }
        });
      } catch (err) {
        console.error("Stream SW init failed:", err);
      }
    };

    setup();

    return () => {
      if (typeof removeListener === "function") {
        removeListener();
      }
    };
  }, [user?.id]);

  useEffect(() => {
    if (taskStatus == "completed" || opportunityId) {
      dispatch(fetchContactCardRequest({ opportunityId, userId: user?.id }));
    }
  }, [taskStatus]);

  // useEffect(() => {
  //   if (opportunityId) {
  //     dispatch(
  //       fetchContactCardRequest({
  //         opportunityId,
  //       })
  //     );
  //   }
  // }, [opportunityId]);

  // useEffect(() => {
  //   if (contactCardData) {
  //     setResult(contactCardData);
  //     setStatus("Completed!");
  //   } else if (error) {
  //     setStatus("Error loading data");
  //   }
  // }, [contactCardData, error]);


  useEffect(() => {
  if (contactCardData) {
    const sortedResult = dynamicSmartSort(contactCardData, "product_icp", {
      isValidFn: (val) => val === true,
      validOnTop: true,
    });
    setResult(sortedResult);
    setStatus("Completed!");

      const pendingMap = {};
      sortedResult.forEach(contact => {
        const key = `${user?.id}_${contact.id}_phone_pending`;
        if (localStorage.getItem(key)) {
          pendingMap[contact.id] = true;
        }
      });
      setPhonePendingMap(pendingMap);
    } else if (error) {
      setStatus("Error loading data");
    }
  }, [contactCardData, error, user?.id]);

  if (taskStatus == "pending" && taskStatus != "failed") {
    return (
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <GeneratingLoader />
      </div>
    );
  }

  const displayCardData = (key, data) => {
    return <div className="col-md-12">
            <div className="contact_map_block">
              <Card className="contact_map_card" onClick={(e)=>{e.preventDefault();onContactCardClick(data)}}>
                <Card.Body>
                  <div className="contact_head_block">
                    <div className="contact_initial_block">
                      {getNameInitials(data?.name)}{" "}
                    </div>

                    {data?.contact_type && (
                      <div className="influencer_block">
                        <img
                          src="/img/contact_ai.png"
                          className="ai_icon"
                          alt="icon"
                        />
                        <p className="influencer_text">
                          {data?.contact_type}
                        </p>
                      </div>
                    )}
               <div className="icon_block" style={{ display: "flex", alignItems: "center", gap: "0.5rem" }}>
                {data?.product_icp && (
                  <div className="chip_cmp gray">
                    ICP
                  </div>
                )}
                <ContactFavContact favoritted={data?.is_shortlisted} contactId={data?.id} opportunityId={data?.opportunity_id} />
              </div>
                  </div>
                  <div className="contact_map_info_block">
                    <div className="contact_map_name_block">
                      <p className="contact_map_name"> {data?.name} </p>
                    </div>
                    <p className="contact_map_designation">{data?.title}</p>
                    <p className="contact_map_details">
                      {[data?.city, data?.country].filter(Boolean).join(", ")}
                    </p>
                   
                   {data?.relevance_reason && <> <hr/><p className="contact_map_details"><ExpandableParagraph text={data?.relevance_reason} wordLimit={5}/></p></>}
                  </div>
                
                  
                  <div className="access_mob_block">
                    <AccessField
                      field_name="email"
                      field_value={data?.email}
                      onAccessClick={(e) =>
                        handleOnAccessEmailClick(
                          e,
                          user?.id,
                          data.id,
                          data.linkedin_url
                        )
                      }
                    />
              {
              phonePendingMap[data.id] ? (
                <div className="fetching_state_cmp">
                  <StatusIndicator text="Fetching Number" />
                </div>
              ) : (phoneMap[data.id] === "Not Found" || data?.phone ==="Not Found")? (
                <span className="access_mob_text_show_cmp">
                  <GenericTagComp color={"red"} onChipClick={() => { }} text={"Not Found"} />
                </span>
              ) : (
                <AccessPhoneButton
                  phone={phoneMap[data.id] || data?.phone}
                  onAccessClick={(e) =>
                    {
                    handleOnAccessPhoneClick(e, user?.id, data.id, true);}
                   
                  }
                  showCopyButton={true}
                  copyToClipboard={(value) => copyToClipboard(value, "phone")}
                />
              )
            }

                    {data.linkedin_url && (
                      <a
                        href={data.linkedin_url}
                        className="access_mob_subbock"
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        <img
                          src="/img/linkedin-logo.png?v=4"
                          alt="LinkedIn"
                          width="15"
                            style={{maxHeight:"2.2rem"}}
                        />
                      </a>
                    )}
                  </div>

                  {/* <GenericTagComp color={"blue"} text={data?.icp_keyword} /> */}
                </Card.Body>
              </Card>
            </div>
          </div>
  }

  return (
    <div className="contact_map_wrapper mt-2">
      {banner && (
              <GenericFloatingBanner
                key={banner.id}
                message={banner.message}
                title={banner.title}
                type={banner.type}
                duration={banner.duration}
                onClose={() => setBanner(null)}
              />
            )}
      <ContactMapCardAddContact opportunityId={opportunityId} contact_list={contact_list}/>
      <div className="container">
        <div className="row">
          {contactCardLoading == true || result === null ? (
            <>
              {[...Array(6)].map((_, i) => (
                <GenericCardSkeletonComponent key={i} />
              ))}
            </>
          ) : Object.keys(result).length === 0 ? (
            <div className="no-data-message">
              <NoDataComp
                message="Content is being generated"
                buttonText="Refresh"
                onButtonClick={() =>
                  dispatch(
                    fetchContactCardRequest({ opportunityId, userId: user?.id })
                  )
                }
              />
            </div>
          ) : (

            <>
            <div className="col-md-6">
              <div className="row">
                {Object.entries(result || {})
                  .filter((_, index) => index % 2 === 0)
                  .map(([key, data]) => (
                    <>{displayCardData(key, data)}</>
                  ))}
              </div>
            </div>

            <div className="col-md-6">
              <div className="row">
                {Object.entries(result || {})
                  .filter((_, index) => index % 2 !== 0)
                  .map(([key, data]) => (
                    <>{displayCardData(key, data)}</>
                  ))}
              </div>
            </div>
            </>
          )
        }
        </div>
      </div>
    </div>
  );
}
